// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"766bc41a","438":"766bc41a","556":"766bc41a","659":"766bc41a","672":"766bc41a","987":"c46ebca9","994":"766bc41a"}[chunkId] + ".chunk.css";
};